export const FAMILY_ID_FIELD_NAME = 'familyId';
export const NEW_FAMILY_HEAD_ID_FIELD_NAME = 'newFamilyHead';
export type ModalType = 'activation' | 'assignment';
